import styled from "styled-components";
import SearcherDestinationButton from "../../components/button/index.js";
export const Destination = styled.div.withConfig({
    displayName: "styled__Destination",
    componentId: "sc-bb45961b-0"
})`
	min-width: calc(80% - 16px);
	max-width: calc(80% - 16px);

	${({ theme  })=>theme.media.between('xs', 'md')} {
		flex-basis: 100%;
		min-width: 100%;
		max-width: 100%;
	}
`;
export const SearcherButton = styled(SearcherDestinationButton).withConfig({
    displayName: "styled__SearcherButton",
    componentId: "sc-bb45961b-1"
})`
	min-width: 20%;
	max-width: 20%;

	${({ theme  })=>theme.media.between('xs', 'md')} {
		flex-basis: 100%;
		min-width: 100%;
		max-width: 100%;
	}
`;

//# sourceMappingURL=styled.js.map